export const CLIENT_ID = window.PAYPAL_CLIENT_ID